const state = {
    selectedLang : 'ua',
}
const actions = {

    // Academic groups

    async GET_ACADEMIC_GROUP_STUDENTS_EDITOR({rootState,dispatch} , body) {
        return await dispatch('ajax/SEND_NEW',
            {
                route:`wsu_study_profiles/group/editor/${body}`,
                method:'GET',
                business : rootState.business.selectedBusiness.alias,
            }, {root : true}
        );
    },

    async ACADEMIC_GROUP_ENROLL_FREE_USERS({rootState,dispatch} , body) {
        return await dispatch('ajax/SEND_NEW',
            {
                route:`wsu_study_profiles/group/enroll_free_users`,
                method:'POST',
                data : body,
                business : rootState.business.selectedBusiness.alias,
            }, {root : true}
        );
    },

    async ACADEMIC_GROUP_ENROLL_APPLICANTS({rootState,dispatch} , body) {
        return await dispatch('ajax/SEND_NEW',
            {
                route:`wsu_study_profiles/group/enroll_applicants`,
                method:'POST',
                data : body,
                business : rootState.business.selectedBusiness.alias,
            }, {root : true}
        );
    },

    async ACADEMIC_GROUP_REMOVE_STUDENTS({rootState,dispatch} , body) {
        return await dispatch('ajax/SEND_NEW',
            {
                route:`wsu_study_profiles/group/remove_students`,
                method:'POST',
                data : body,
                business : rootState.business.selectedBusiness.alias,
            }, {root : true}
        );
    },

    async MOVE_TO_SUBGROUP({rootState,dispatch} , body) {
        return await dispatch('ajax/SEND_NEW',
            {
                route:`wsu_study_profiles/group/subgroup`,
                method:'POST',
                data : body,
                business : rootState.business.selectedBusiness.alias,
            }, {root : true}
        );
    },











}

export default {
    namespaced:true,
    actions,
    state

}